// src/config/storageKeys.ts
// Centralized localStorage key constants for better maintainability

export const STORAGE_KEYS = {
  // Authentication keys
  USERNAME: 'username',
  USER_ID: 'userId',
  MERCHANT_ID: 'merchantId',
  USER_ROLES: 'userRoles',
  
  // Localization keys
  LANGUAGE: 'lang',
  
  // Merchant-specific keys
  MERCHANT_TIMEZONE: 'merchant_tz',
} as const;

export type StorageKey = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS];
